import React, { useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { useModal } from "react-modal-hook";
import styled from "styled-components";

import { EntityAvatar } from "../../../common/components";
import { Contact } from "../../../types/common";
import { getNameInitial } from "../../../utils/common";

type openContractHandler = {
    isSubmitting: boolean;
    handler: (
        contact: Contact,
    ) => void;
};


const useOpenContractInfoHandler = (): openContractHandler => {

    const [contact, setContact] = useState<Contact>();
    
    const [show, hide] = useModal(() => {
        return (
            <EntityInfoModal show onHide={hide} centered>
                <Modal.Body className="py-5">
                    <h1 className="text-center mb-2">
                        <EntityAvatar variant="large">
                            {getNameInitial(contact!!.company)}
                        </EntityAvatar>
                    </h1>
                    <h2 className="text-center mb-3">
                        {contact!!.company ?? ""}
                    </h2>
                    <Row xs={2} className={'px-5'}>
                        {contact!!.contactPerson && (
                            <Col>
                                <p className="mt-3 mb-2 text-label-grey">
                                    Contact Person
                                </p>
                                <p className="fw-bold">
                                    {contact!!.contactPerson}
                                </p>
                            </Col>
                        )}
                        {contact!!.phone && (
                            <Col>
                                <p className="mt-3 mb-2 text-label-grey">
                                    Contact Number
                                </p>
                                <p className="fw-bold">{contact!!.phone}</p>
                            </Col>
                        )}
                        {contact!!.email && (
                            <Col xs={12}>
                                <p className="mt-3 mb-2 text-label-grey">
                                    Email
                                </p>
                                <p className="fw-bold">{contact!!.email}</p>
                            </Col>
                        )}
                    </Row>
                </Modal.Body>
            </EntityInfoModal>
        );
    }, [contact]);

    return {
        isSubmitting: false,
        handler: (contact) => {
            setContact(contact)
            show();
        },
    };
};

const EntityInfoModal = styled(Modal)`
    .modal-dialog {
        max-width: 600px;
    }
`;

export default useOpenContractInfoHandler;
